import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const TabWrapper = styled.div`
  //position: sticky;
  & > div {
    width: calc(100% + 30px);
    /* box-shadow: 0 6px 0 0 #bbb; */
    //box-shadow: 0 0 6px 0 #b9b9b9;
    margin: 0 -30px 0 0;
    padding: 8px;
    border: 1px solid ${Variables.colors.complementary_400};
    border-radius: 4px;
    & > div:first-child {
      position: unset;
      //width: 100vw;
    }
    & > div:last-child {
      & > div {
        box-shadow: unset;
        margin: unset;
        border: unset;
        border-radius: unset;
        width: 100%;
      }
    }
  }
`;

export const FieldContainer = styled.div`
  display: ${props => (props.hidden ? "none" : "flex")};
  flex-direction: ${props => (props.group ? "column" : "row")};
  padding: 20px 0;
  border-bottom: ${props =>
    props.borderLess ? "" : `solid 1px ${Variables.colors.complementary_300}`};
  .group {
    display: flex;
    &:not(:first-child) {
      margin-top: 18px;
    }
  }
  .notice {
    font-size: ${Variables.font_sizes.small};
    color: ${Variables.colors.red_500};
  }
  .label {
    display: flex;
    align-items: center;
    &.top {
      align-items: start;
    }
    width: 40%;
    font-size: ${Variables.font_sizes.x_small};
    color: ${Variables.colors.complementary_700};
    font-weight: ${Variables.font_weight.medium};
    &.bold {
      font-weight: ${Variables.font_weight.bold};
      color: ${Variables.colors.complementary_800};
    }
    i {
      vertical-align: middle;
      margin-right: 8px;
      &:before {
        font-size: 16px;
      }
    }
  }
  .unit {
    margin-right: 4px;
    font-size: ${Variables.font_sizes.x_small};
    font-weight: ${Variables.font_weight.light};
  }
  .value {
    width: 60%;
    line-height: 1.7;
    font-size: ${props =>
      props.largeFont
        ? Variables.font_sizes.large
        : Variables.font_sizes.x_medium};
    &.largeFont {
      font-size: ${Variables.font_sizes.large};
    }
    &.bold {
      font-weight: ${Variables.font_weight.bold};
    }
    &.reverse {
      unicode-bidi: plaintext;
      text-align: right;
    }
    &.row-reverse {
      display: flex;
      & > i {
        margin-right: 0;
        margin-left: 10px;
      }
    }
    color: ${Variables.colors.complementary_800};
    text-align: justify;
    .select-box-container {
      width: 116px;
      height: 27px;
    }
    .label-link-box {
      margin-right: 1px;
      color: ${Variables.colors.complementary_800};
      font-size: ${Variables.font_sizes.x_small};
      font-weight: ${Variables.font_weight.medium};
    }
    .link-box-container {
      margin-top: 6px;
    }
    .num {
      display: flex;
      width: fit-content;
      direction: ltr;
      &.red {
        color: ${Variables.colors.red_500};
      }
    }
    .detail {
      margin-top: 8px;
      display: flex;
      color: ${Variables.colors.complementary_700};
      font-size: ${Variables.font_sizes.x_small};
      font-weight: ${Variables.font_weight.light};
    }
    & > i {
      margin-right: 20px;
      height: 32px;
      width: 32px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      vertical-align: middle;
      cursor: pointer;
      &:before {
        margin: 0;
        font-size: 16px;
        color: ${Variables.colors.complementary_800};
      }
      &:hover {
        background-color: ${Variables.colors.complementary_400};
      }
    }
    .flex-container {
      display: flex;
      align-items: center;
      .payment-info {
        display: flex;
        align-items: center;
        & > i {
          margin: 0 20px 0 8px;
        }
      }
    }
    .flex-wrap {
      display: flex;
      flex-wrap: wrap;
      & > div {
        margin-left: 8px;
        margin-bottom: 8px;
      }
    }
  }
`;

export const GiantHeader = styled.div`
  padding: 16px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${Variables.font_sizes.x2_large};
  color: ${Variables.colors.complementary_800};
  cursor: ${props => (props.open === undefined ? "" : "pointer")};

  .right-part{
    display: flex;
    align-items: center;
  }
  .left-part {
    display: flex;
    align-items: center;
  }
  .eye-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    :hover {
      background-color: ${Variables.colors.complementary_400};
    }
  }
  .arrow-icon{
    display: flex;
    justify-content: flex-end;
    margin-right: 24px;
    padding: 2px 4px;
    transform: ${props => (props.open ? "rotate(90deg)" : "rotate(-90deg)")};
    &:before{
      font-size: 18px;
      color: ${Variables.colors.complementary_700};
    }
  }
  &:hover{
    background-color: ${props =>
      props.open === undefined ? "" : Variables.colors.complementary_200};
  }
}
  .icon-container {
    margin-left: 12px;
    display: flex;
    &>i {
      &:before {
        color: ${Variables.colors.green};
        font-size: 20px;
      }
    }

`;

export const LogBox = styled.div`
  transition: opacity 1s ease-out;
  height: ${props => (props.show ? "auto" : "0")};
  opacity: ${props => (props.show ? "1" : "0")};
  overflow: hidden;
  padding: 0 38px;
  
  // width: calc(100% + 30px);
  // margin-right: -30px;
  // margin-top: 4px;
  // box-shadow: 0 0 6px 0 ${Variables.colors.complementary_450};
  // border: 1px solid ${Variables.colors.complementary_400};
  // border-radius: 4px;
  // background-color: ${Variables.colors.complementary};
  // padding: 28px 0 0 0;
  .title {
    margin-right: 32px;
    margin-bottom: 28px;
    display: flex;
    align-items: center;
    font-size: ${Variables.font_sizes.x2_large};
    color: ${Variables.colors.complementary_800};
    .icon-container {
      margin-left: 12px;
      display: flex;
      i {
        &:before {
          color: ${Variables.colors.green};
          font-size: 20px;
        }
      }
    }
  }
`;

export const LogBoxWrapper = styled.div`
  width: calc(100% + 30px);
  margin-right: -30px;
  margin-top: 4px;
  border: 1px solid ${Variables.colors.complementary_400};
  border-radius: 4px;
  background-color: ${Variables.colors.complementary};
  margin-bottom: 16px;
`;
